module.exports = __webpack_public_path__ + "static/media/carpooling6.905de03d.PNG";